<script setup lang="ts">
import type { HTMLAttributes } from "vue"
import { DotsHorizontalIcon } from "@radix-icons/vue"
import { PaginationEllipsis, type PaginationEllipsisProps } from "radix-vue"
import { useClass } from "~/composables/local/cn-class"

const { class: rawClass, ...props } = defineProps<PaginationEllipsisProps & { class?: HTMLAttributes["class"] }>()

const className = useClass(
	"size-9 flex items-center justify-center",
	() => rawClass,
)
</script>

<template>
	<PaginationEllipsis
		v-bind="props"
		:class="className">
		<slot>
			<DotsHorizontalIcon class="rtl:rotate-180" />
		</slot>
	</PaginationEllipsis>
</template>
